import { useEffect, useState } from "react";
import axios from "axios";
import envUrls from "../utils/config";

// Projects only Wind Pioneers users see (hidden from everyone else)
const WIND_PIONEERS_PROJECTS = ["windscribe", "windwizz"];
const WIND_PIONEERS_DOMAIN = "@wind-pioneers.com";

const getLoggedInEmail = () => {
  const found = document.cookie
    .split(";")
    .find((c) => c.trim().split("=")[0] === "email_windbug");
  if (!found) return "";
  return decodeURIComponent(found.split("=")[1] || "")
    .replace(/"/g, "")
    .trim()
    .toLowerCase();
};

// True when the logged-in user has a @wind-pioneers.com email
export const isWindPioneersUser = () =>
  getLoggedInEmail().endsWith(WIND_PIONEERS_DOMAIN);

// True for the projects only Wind Pioneers users can see
export const isWindPioneersProject = (projectName) =>
  WIND_PIONEERS_PROJECTS.includes((projectName || "").toLowerCase());

const normalizeSubToolItem = (item) => {
  if (typeof item === "string") return item.trim();
  if (item && typeof item === "object") {
    return (
      item.sub_tool_name ||
      item.sub_tool ||
      item.subtool_name ||
      item.subtool ||
      item.name ||
      item.label ||
      item.value ||
      Object.entries(item).find(
        ([k, v]) =>
          typeof v === "string" &&
          ![
            "id",
            "project_name",
            "project_type",
            "created_at",
            "updated_at",
          ].includes(k.toLowerCase())
      )?.[1] ||
      ""
    ).trim();
  }
  return "";
};

const extractSubTools = (responseData) => {
  if (!responseData) return [];
  let rawList = [];

  if (Array.isArray(responseData)) {
    rawList = responseData;
  } else if (Array.isArray(responseData.data)) {
    rawList = responseData.data;
  } else if (Array.isArray(responseData.sub_tools)) {
    rawList = responseData.sub_tools;
  } else if (Array.isArray(responseData.subTools)) {
    rawList = responseData.subTools;
  }

  return rawList.map(normalizeSubToolItem).filter(Boolean);
};

// Fetches the project list (GET /list_projects) and sub-tools list (GET /list_sub_tools).
const useProjects = () => {
  const [projects, setProjects] = useState([]);
  const [subTools, setSubTools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${envUrls.baseUrl}list_projects`, { withCredentials: true })
      .then((response) => {
        const allProjects = (response.data?.data || []).map((item) => ({
          ...item,
          project_name:
            (item.project_name || "").trim().toLowerCase() === "windvista v2"
              ? "WindVista_V2"
              : item.project_name,
        }));
        // Wind Pioneers users see every project; everyone else sees every
        // project except the Wind Pioneers ones.
        setProjects(
          isWindPioneersUser()
            ? allProjects
            : allProjects.filter(
                (item) => !isWindPioneersProject(item.project_name)
              )
        );
      })
      .catch((error) => {
        console.log(error);
        setProjects([]);
      })
      .finally(() => setLoading(false));

    axios
      .get(`${envUrls.baseUrl}list_sub_tools`, { withCredentials: true })
      .then((response) => {
        setSubTools(extractSubTools(response.data));
      })
      .catch((error) => {
        console.log(error);
        setSubTools([]);
      });
  }, []);

  return { projects, subTools, loading };
};

export default useProjects;
